var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCornering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.106,
    height: 17.469,
    viewBox: "0 0 11.106 17.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_weather-refresh-alt",
    "data-name": "Icon weather-refresh-alt",
    d: "M14.136,20.939a7.353,7.353,0,0,0,.983,3.742,7.161,7.161,0,0,0,2.707,2.707,7.477,7.477,0,0,0,3.759,1,1.045,1.045,0,0,0,.828-.379,1.253,1.253,0,0,0,.345-.879,1.149,1.149,0,0,0-1.19-1.155,5,5,0,0,1-5.035-5.035,4.944,4.944,0,0,1,1.38-3.483,4.3,4.3,0,0,1,3.242-1.483l-.569.552a1.077,1.077,0,0,0-.362.845,1.192,1.192,0,0,0,.345.828,1.1,1.1,0,0,0,.845.362,1.2,1.2,0,0,0,.879-.362l2.6-2.587a1.069,1.069,0,0,0,.345-.879.927.927,0,0,0-.345-.81l-2.6-2.638a1.1,1.1,0,0,0-.845-.362,1.237,1.237,0,0,0-1.224,1.224,1.1,1.1,0,0,0,.379.879l.517.483a7.339,7.339,0,0,0-4.984,2.328A7.209,7.209,0,0,0,14.136,20.939Z",
    transform: "translate(-14.136 -10.92)",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornering);
export default __webpack_public_path__ + "static/media/cornering.afd6bcc755fb1d6222973c926b29428f.svg";
export { ForwardRef as ReactComponent };